import { createContext } from 'react'

const LangCtx = createContext({})

export default LangCtx
